import { data } from '../../svg/Number/data';
import { makeIcon } from '../makeIcon';

export const Number = makeIcon(data, 'number', 'Number');

export default Number;
